module.exports = __webpack_public_path__ + "static/media/mattermix-logo.89ca7d73.svg";